import { DependencyList, useCallback, useEffect, useState } from "react";

export default function useAsyncUpdate<T>(updateFunc: () => Promise<T>, deps?: DependencyList): [T | undefined, () => void] {
  const [value, setValue] = useState<T>();
  const update = useCallback(() => {
    updateFunc().then(setValue);
  }, deps ?? []);
  useEffect(update, [update]);

  return [value, update];
}

export function useAsyncUpdateWithArgs<UpdateFunc extends (requestData: any) => Promise<any>>(updateFunc: UpdateFunc, defaultData?: Parameters<UpdateFunc>[0], deps?: DependencyList): [Awaited<ReturnType<UpdateFunc>> | undefined | null, (arg: Parameters<UpdateFunc>[0]) => void] {
  const [value, setValue] = useState<Awaited<ReturnType<UpdateFunc>>>();

  const update = useCallback(
    (requestData?: Parameters<UpdateFunc>[0]) => {
      if (defaultData || requestData) {
        updateFunc(requestData ?? defaultData).then(setValue);
      }
    },
    deps ?? []
  );

  useEffect(update, [update]);

  return [value, update];
}